import { apply, setAttr, remove } from "@directus/visual-editing";

let isApplied = false;

export async function initializeVisualEditor() {
  if (typeof window !== "undefined" && !isApplied) {
    try {
      await apply({
        directusUrl: "https://hello-storage.directus.app/",
        onSaved: async (data) => {
          try {
            window.location.reload();
          } catch (error) {
            console.error("Failed to refresh page data:", error);
            window.location.reload();
          }
        },
      });
      isApplied = true;
    } catch (error) {
      console.error("Failed to initialize visual editor:", error);
    }
  }
}

export function cleanupVisualEditor() {
  if (typeof window !== "undefined" && isApplied) {
    remove();
    isApplied = false;
  }
}

export { setAttr };
